import styled from "styled-components";
import { Drawer, Layout, Menu } from "antd";

export const DrawerSider = styled(Drawer)`
  z-index: 99999999999;
  .ant-drawer-wrapper-body {
    position: relative;
    .ant-drawer-header {
      right: 16px;
      top: 24px;
      padding: 0;
      position: absolute;
    }
    .ant-drawer-body {
      padding: 0;
      background: var(--dark-3);
    }
  }
`;

export const LayoutSider = styled(Layout.Sider)`
  top: 0;
  left: 0;
  z-index: 11;
  height: 100%;
  position: fixed;
  box-shadow: 0px 0px 48px rgba(0, 0, 102, 0.08);

  &.expandedSidebar {
    width: 192px !important;
    min-width: 192px !important;
    max-width: 192px !important;
  }

  .ant-layout-sider-children {
    background-color: var(--dark-3);
  }
`;

export const Modules = styled(Menu)`
  overflow-y: auto;
  overflow-x: hidden;
  border-right: none;
  height: calc(100% - 64px);
  background-color: var(--veloprime-bg-primary) !important;

  @media only screen and (max-device-width: 812px) {
    height: calc(100% - 66px);
  }
`;

export const Module = styled(Menu.Item)`
  color: var(--white) !important;
  margin: 0 !important;
  height: 64px !important;
  padding-left: 20px !important;
  background-color: var(--veloprime-bg-primary);
  transition: color 500ms ease-in-out;

  &:first-of-type {
    border-top: 1px solid var(--veloprime-bg-dark);
  }

  * {
    z-index: 1;
  }

  &.logout {
    bottom: 0;
    left: -1px;
    position: absolute;
    border-top: 1px solid var(--veloprime-bg-dark);
  }

  &.conta {
    bottom: 64px;
    left: -1px;
    position: absolute;
    border-top: 1px solid var(--veloprime-bg-dark);
  }

  svg {
    margin-right: 4px;
    &.no-fill {
      stroke: var(--ghost);
      transition: stroke 0.3s ease-in-out;
    }
  }

  &.ant-menu-item:active {
    background-color: var(--veloprime-bg-dark) !important;
  }
  &.ant-menu-item-selected {
    background-color: var(--veloprime-bg-dark) !important;
    &::after {
      border-right: none;
      opacity: 0;
    }
    &::before {
      opacity: 1;
    }
  }

  &::before {
    content: "";
    top: 8px;
    left: 10px;
    z-index: 0;
    opacity: 0;
    position: absolute;
    border-radius: 4px;
    width: calc(100% - 20px);
    height: calc(100% - 16px);
    background-color: var(--veloprime-bg-dark);
    transition: opacity 500ms ease-in-out;
  }

  &:hover {
    color: var(--ant-primary-color) !important;
    svg {
      color: var(--ant-primary-color) !important;
    }
    svg:not(.no-fill) {
      fill: var(--ant-primary-color) !important;
    }
    svg.no-fill {
      stroke: var(--ant-primary-color) !important;
    }
  }

  &.ant-menu-item-selected {
    color: var(--ant-primary-color) !important;
    svg {
      color: var(--ant-primary-color);
    }
    svg:not(.no-fill) {
      fill: var(--ant-primary-color);
    }
    svg.no-fill {
      stroke: var(--ant-primary-color);
    }
  }
`;

export const SessionContainer = styled.div`
  height: 64px;
  display: flex;
  flex-direction: column;
  background-color: var(--dark-3);
`;

export const ActionContainer = styled.div`
  width: 100%;
  height: 64px;
  padding: 8px;
  border-top: 1px solid var(--veloprime-bg-dark);

  .active {
    color: var(--ant-primary-color);
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  font-size: 12px;
  transition: 0.3s;

  &:hover {
    color: var(--ant-primary-color);
    transition: 0.3s;
    &.logout {
      color: var(--ant-error-color);
    }
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
